import { render, staticRenderFns } from "./Fund-addToHome.vue?vue&type=template&id=ef81c7b2&scoped=true&"
import script from "./Fund-addToHome.vue?vue&type=script&lang=js&"
export * from "./Fund-addToHome.vue?vue&type=script&lang=js&"
import style0 from "./Fund-addToHome.vue?vue&type=style&index=0&id=ef81c7b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef81c7b2",
  null
  
)

export default component.exports